export class ScheduledUpdatesMigrationStatements {
  migrations = [`
    CREATE TABLE IF NOT EXISTS scheduled_updates (
      id        TEXT PRIMARY KEY,
      json      TEXT
    );`
  ]
}
